"use client";
import { jsxs as t, jsx as a } from "react/jsx-runtime";
const o = ({
  title: i,
  titleId: h,
  desc: l,
  descId: r,
  ...e
}) => /* @__PURE__ */ t(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    width: 24,
    height: 24,
    "aria-labelledby": h,
    "aria-describedby": r,
    ...e,
    children: [
      l ? /* @__PURE__ */ a("desc", { id: r, children: l }) : null,
      i ? /* @__PURE__ */ a("title", { id: h, children: i }) : null,
      /* @__PURE__ */ a("path", { d: "M7 13.333a1.013 1.013 0 0 1 1-1h10.667a1 1 0 0 1 0 2H8a1.013 1.013 0 0 1-1-1m1-3h10.667a1 1 0 1 0 0-2H8a1 1 0 0 0 0 2m4 11.334H8a1 1 0 1 0 0 2h4a1 1 0 0 0 0-2m16.56 6.093A2.667 2.667 0 0 1 26.267 29H5.333A2.347 2.347 0 0 1 3 26.667V5.333A2.347 2.347 0 0 1 5.333 3h16a2.347 2.347 0 0 1 2.334 2.333v9.187c.356.274.64.631.826 1.04l4.267 9.6a2.732 2.732 0 0 1-.2 2.6m-13.333-2.6 3.293-7.413a1 1 0 0 1-.907.586H8a1 1 0 1 1 0-2h9.627a1.014 1.014 0 0 1 1.04 1c0 .123-.023.245-.067.36l.947-2.133a2.667 2.667 0 0 1 2.16-1.573V5.333A.334.334 0 0 0 21.333 5h-16A.333.333 0 0 0 5 5.333v21.334a.333.333 0 0 0 .333.333h9.787a2.667 2.667 0 0 1 .12-1.84zm11.693.813-4.253-9.6a.642.642 0 0 0-.334-.36h-.08a.707.707 0 0 0-.92.387L17.067 26a.72.72 0 0 0 0 .693.706.706 0 0 0 .613.334h8.533a.706.706 0 0 0 .614-.334.72.72 0 0 0 .106-.72zM21.987 19a1.013 1.013 0 0 0-1 1v2.133a1 1 0 1 0 2 0V20A1.013 1.013 0 0 0 22 19zm0 4.667a1 1 0 1 0 1 1 1.014 1.014 0 0 0-.987-1z" })
    ]
  }
);
export {
  o as default
};
